import { render, staticRenderFns } from "./TradesToDosFilters.vue?vue&type=template&id=0dbd781f&scoped=true&"
import script from "./TradesToDosFilters.vue?vue&type=script&lang=ts&"
export * from "./TradesToDosFilters.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dbd781f",
  null
  
)

export default component.exports